import type { PdfDocumentDefinition, SignatureRole } from './types';

/** Who signs a form follows from its signature boxes: a participant box means the participant signs; a parent or
 * guardian box means a parent signs for a minor, younger than the event's age for signing alone on the day of signing. An
 * adult signs alone: a parent or guardian's signature is neither asked for nor taken. */
const ROLES: readonly SignatureRole[] = ['participant', 'parent'];
const hasBox = (document: Pick<PdfDocumentDefinition, 'placements'>, role: SignatureRole) =>
  document.placements.some(p => p.kind === 'signature' && p.source.kind === 'signature' && p.source.role === role);

/** Who signs for this participant, each of them required. */
export function pdfRequiredSigners(document: Pick<PdfDocumentDefinition, 'placements'>, minor: boolean): SignatureRole[] {
  return ROLES.filter(role => hasBox(document, role) && (role === 'participant' || minor));
}

